import type { RegistrationStageCode, RegistrationStageStatus } from './api';

/** The gates, in the order they must be passed. */
export const STAGE_ORDER: readonly RegistrationStageCode[] = ['AP', 'PUSPAKOM', 'JPJ'];

/** NKS's words. These are the Malaysian bodies, not our abstractions. */
export const STAGE_LABEL: Record<RegistrationStageCode, string> = {
  AP: 'AP',
  PUSPAKOM: 'Puspakom',
  JPJ: 'JPJ',
};

export const STAGE_DESCRIPTION: Record<RegistrationStageCode, string> = {
  AP: 'Approved permit — the import permit. Nothing moves without it.',
  PUSPAKOM: 'Mandatory inspection. Puspakom will not book one without the AP.',
  JPJ: 'Registration and number plate. Needs the Puspakom pass first.',
};

export const STAGE_STATUS_LABEL: Record<RegistrationStageStatus, string> = {
  PENDING: 'Not started',
  IN_PROGRESS: 'In progress',
  DONE: 'Done',
  BLOCKED: 'Blocked',
};

/** Reserved status band from antd-theme.ts, never the brand colour. */
export function stageTone(status: RegistrationStageStatus): string | undefined {
  switch (status) {
    case 'DONE':
      return 'success';
    case 'IN_PROGRESS':
      return 'processing';
    case 'BLOCKED':
      return 'error';
    default:
      return undefined;
  }
}

/**
 * How late is too late to show in black.
 *
 * A stage one day over target is worth seeing but not worth shouting about; a
 * week over is the thing the dashboard exists for. Two bands rather than a
 * gradient, because a dashboard where everything is a slightly different shade
 * of orange is a dashboard nobody reads.
 */
export const BADLY_OVERDUE_DAYS = 7;

export function overdueTone(days: number | null): 'danger' | 'warning' | undefined {
  if (days === null || days <= 0) return undefined;
  return days >= BADLY_OVERDUE_DAYS ? 'danger' : 'warning';
}
